import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  AfterViewChecked,
  ViewEncapsulation,
  HostListener,
} from '@angular/core';
import { of, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AppContext } from 'src/app/services/app-context.service';

@Component({
  selector: 'travel-ui-autosuggest',
  templateUrl: './autosuggest.component.html',
  styleUrls: ['./autosuggest.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AutosuggestComponent implements OnInit, AfterViewChecked {
  @Input()
  set isOpened(data: boolean) {
    this.isOptionPanelOpened = data;
  }
  @Input()
  set stringToShow(data: string) {
    this.searchStr = data;
  }
  @Input() showLoader = false;
  @Input() loaderUrl = '';
  @Output() openedFromInside = new EventEmitter();
  @ViewChild('trigger', { static: true }) input!: ElementRef;
  searchPlaceholder = 'City name, airport, hotel, or landmark';
  SharecareSearchPlaceHolder = 'Search by City or Hotel name or Airport'
  selectedOption: any = {};
  popoverWidth: number | undefined;
  isOptionPanelOpened = false;
  searchStr = '';
  @Output() close = new EventEmitter();

  subject: Subject<string> = new Subject();

  constructor(private eRef: ElementRef, public appContext: AppContext,) { }

  ngOnInit() {
    this.subject.pipe(debounceTime(300)).subscribe(() => {
      if (this.searchStr && this.searchStr.length > 2) {
        this.isOptionPanelOpened = true;
        this.openedFromInside.emit({
          searchStr: this.searchStr,
        });
      }
    });
  }

  @HostListener('document:click', ['$event'])
  clickout(event: { target: any }) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.close.emit();
    }
  }

  getInput() {
    this.searchStr = '';
  }

  initiateSearch() {
    this.subject.next('');
  }

  getOffseWidth() {
    this.popoverWidth =
      this.input.nativeElement?.elementRef?.nativeElement?.offsetWidth ?? 500;
  }

  onResize(event: any) {
    this.getOffseWidth();
  }

  getClickedOption(option: any) {
    this.selectedOption = option;
    this.isOptionPanelOpened = false;
  }

  closeOptionPanel() {
    this.isOptionPanelOpened = false;
  }

  ngAfterViewChecked(): void {
    this.getOffseWidth();
  }
}
